import api from "../axios";
import baseUrl from "../baseUrl";

export default {
  // 分享页面根据学校id获取学校简介
  getDescribe(params) {
    return api.getParams(baseUrl + "api/public/school/describe/get", params);
  },
  // 校企合作申请列表
  getCoopList(params) {
    return api.post(baseUrl + "api/enterprise/school/recruit/get", params)
  },
  // 获取所有学校
  getSchool(page, pageSize, params) {
    return api.post(baseUrl + `api/enterprise/school/list/${page}/${pageSize}`, params)
  },
  // 获取双选会学校
  getDoubleSchool(params) {
    return api.get(baseUrl + `api/enterprise/sxh/school/list`, params)
  },
  // 添加学校
  applyAdd(params) {
    return api.post(baseUrl + "api/enterprise/school/recruit/add", params);
  },
  // 添加意向
  addIntention(params) {
    return api.post(baseUrl + "api/enterprise/school/intention/add", params)
  },
  // 意向列表
  getIntention(params) {
    return api.post(baseUrl + "api/enterprise/school/intention/list", params)
  },
  // 邀请函内容
  getInviteInfo(id) {
    return api.get(baseUrl + `api/school/invite/code/get/${id}`)
  },
  getSchoolInfo(schoolId) {
    return api.get(baseUrl + `api/enterpise/school/info/get/${schoolId}`)
  },
  getLogo(schoolId) {
    return api.get(`${baseUrl}api/vanber/school/logo/get/${schoolId}`)
  },
  // 获取学校列表
  getSchoolList() {
    return api.get(baseUrl + "api/school/list/all");
  },
  getMajorList(params) {
    return api.get(baseUrl + "api/school/public/majors",params);
  },
  // 按省份返回学校列表
  getAllSchool() {
    return api.get(baseUrl + 'api/enterprise/school/list/province')
  },
  // 获取需要付费的合作学校id列表
  getPaySchoolIds(){
    return api.get(baseUrl + 'api/common/pay/school/list')
  }
}